import { render, staticRenderFns } from "./OrderedArticleList.vue?vue&type=template&id=7367f2ed"
import script from "./OrderedArticleList.vue?vue&type=script&lang=ts"
export * from "./OrderedArticleList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports